module.exports = __webpack_public_path__ + "static/media/reporting-license.9b2eed49.png";